import { LinkItem } from '../../../../design-system';
import { routeCreator } from '../../utils';

export const getAudienceUpdatePageHeaderLinks = (pageLabel: string): LinkItem[] => [
  {
    to: routeCreator.base(),
    label: 'Audiences',
  },
  {
    key: '/audiences/update/audience-name',
    label: pageLabel,
  },
];
